'use strict';
import {gsap} from 'gsap';

var _this;

class MenuDesktop {

    constructor(menuContainer) {

        _this = this;
        this.container = menuContainer;
        //this.objClicked = null;
        //this.subMenuClicked = null;
        //this.objActive = null;
        //this.subMenuActive = null;
        this.animMenuDesktopComplete = true;
        //this.timeAniamation = 0.4;
        //this.timeAniamationDelay = 0.2;

        this.container.find('.has-child').click(function (e) {
            e.preventDefault();

            _this.menu($(this));
        });

        // $('.frame-shadow-all-site').click(function(){
        // 	_this.menu($(this),true);
        // });

    }

    menu(obj, forceClose) {

        let objClicked = obj;
        let subMenuClicked = obj.next('.wrap-sub-menu');
        let objActive = $('.nav-menu-desktop .has-child.active');
        let subMenuActive = objActive.next('.wrap-sub-menu');

        if (forceClose == undefined) {
            forceClose = false;
        } else if (forceClose) {
            objClicked = _this.container.find('a.active');
            subMenuClicked = objClicked.next('.wrap-sub-menu');
            subMenuActive = objClicked.next('.wrap-sub-menu');
        }


        if (!_this.animMenuDesktopComplete)
            return;

        _this.animMenuDesktopComplete = false;

        if (objClicked.hasClass('active') || forceClose) {
            //close
            //$('.frame-shadow-all-site').fadeOut();


            $(_this.container).find('ul > li a').css('opacity', 1);
            objClicked.removeClass('active');
            gsap.to(subMenuClicked, 0.5, {
                opacity: '0', top: '-=10px', onComplete: function () {
                    gsap.to(subMenuClicked, 0, {display: 'none', top: '+=10px', immediateRender: true});
                    //if($('.frame-shadow-all-site').css('display') == 'none')
                    //gsap.fromTo($('.frame-shadow-all-site'), 0.2, {display: 'inline', opacity: '1'} , {display: 'none', opacity: '0'});

                    _this.animMenuDesktopComplete = true;
                },
            });


        } else {
            objClicked.addClass('active');
            //$('.frame-shadow-all-site').fadeIn();

            // if($('.frame-shadow-all-site').css('display') == 'none')
            // 	gsap.fromTo($('.frame-shadow-all-site'), 0.5, {display: 'none', opacity: '0'} , {display: 'inline', opacity: '1', delay:0.3});

            $(_this.container).children('ul:first-child').find('> li', this).find('a').css('opacity', 0.5);
            /*gsap.fromTo(subMenuClicked, 0.5, {display: 'inline', opacity: '0', top: '-=10px'} , {opacity: '1', top: '+=10px', onComplete: function(){
             animMenuDesktopComplete = true;
             },
             });*/
            gsap.fromTo(subMenuClicked, 0.2, {display: 'inline', opacity: '0', top: '-=10px'}, {
                opacity: '1', top: '+=10px', onComplete: function () {
                    _this.animMenuDesktopComplete = true;
                },
            });

            //close
            objActive.removeClass('active');
            if (subMenuActive.length > 0)
                gsap.to(subMenuActive, 0, {
                    opacity: '0', immediateRender: true, onComplete: function () {
                        gsap.to(subMenuActive, 0, {display: 'none', immediateRender: true});
                        _this.animMenuDesktopComplete = true;
                    },
                });
        }


    }


}

export default MenuDesktop


// WEBPACK FOOTER //
// ./scripts/components/menuDesktop.js